import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareNumberField from '../../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareSelectField from '../../../../common/inputfields/ErrorAwareSelectField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import { calcBusinessDays, calcDays } from '../../../../common/filters/DateUtil'
import { toDateFormat } from '../../../../../utils/Util';

class NewVacation extends Component {

    state = {
        newAgain: false,
        selectedType: enums.vacationTypes[0],
        selectedEmployee: {},
        startDate: new Date(),
        endDate: new Date(),
        days: 1,
        partnerDisabled: false,
        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
        if (this.props.row) {
            console.log(this.props.row);
            this.setState({ partnerDisabled: true, selectedEmployee: { label: this.props.row.employee.name, value: this.props.row.employee.privateId } })
        }
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedType: enums.vacationTypes[0],
            selectedEmployee: {},
            startDate: new Date(),
            endDate: new Date(),
            days: 1,
            errors: new Map(),
            partnerDisabled: false,
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/vacation';
        const requestObject = {
            "type": this.state.selectedType.value,
            "employeeId": this.state.selectedEmployee.value,
            "startDate": toDateFormat(this.state.startDate),
            "endDate": toDateFormat(this.state.endDate),
            "days": this.state.days,
        };
        handlePost(path, requestObject, this);
    };

    handleStartDateChangeEvent = (e) => {
        if (this.state.endDate) {
            let d = 0;
            if (this.state.selectedType && this.state.selectedType.value !== 'GOV_PAID_SICK_LEAVE') {
                d = calcBusinessDays(e, this.state.endDate);
            } else {
                d = calcDays(e, this.state.endDate);
            }
            this.setState({ days: d })
        }
        this.setState({ startDate: e })
    }

    handleEndDateChangeEvent = (e) => {
        if (this.state.startDate) {
            let d = 0;
            if (this.state.selectedType && this.state.selectedType.value !== 'GOV_PAID_SICK_LEAVE') {
                d = calcBusinessDays(this.state.startDate, e);
            } else {
                d = calcDays(this.state.startDate, e);
            }
            this.setState({ days: d })
        }
        this.setState({ endDate: e })
    }

    handleTypeChangeEvent = (e) => {
        if (this.state.startDate && this.state.endDate) {
            let d = 0;
            if (e.target.value.value !== 'GOV_PAID_SICK_LEAVE') {
                d = calcBusinessDays(this.state.startDate, this.state.endDate);
            } else {
                d = calcDays(this.state.startDate, this.state.endDate);
            }
            this.setState({ days: d })
        }
        this.setState({ selectedType: e.target.value })
    }

    disableDays = (date) => {
        let date1 = date.setHours(0, 0, 0, 0);
        let result = false;
        if (this.state.vacations) {
            this.state.vacations.forEach(element => {
                let date2 = new Date(element.startDate).setHours(0, 0, 0, 0);
                let date3 = new Date(element.endDate).setHours(0, 0, 0, 0);
                if (date1 >= date2 && date1 <= date3) {
                    console.log(new Date(date1));
                    result = true;
                }
            });
        }
        return result;
    }

    disableDaysForEndDate = (date) => {
        let date1 = date.setHours(0, 0, 0, 0);
        let date2 = this.state.startDate.setHours(0, 0, 0, 0);
        let result = false;
        if (date1 < date2) {
            result = true;
        } else if (this.state.vacations) {
            this.state.vacations.forEach(element => {
                let date2 = new Date(element.startDate).setHours(0, 0, 0, 0);
                let date3 = new Date(element.endDate).setHours(0, 0, 0, 0);
                if (date1 >= date2 && date1 <= date3) {
                    console.log(new Date(date1));
                    result = true;
                }
            });
        }
        return result;
    }

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled={this.state.partnerDisabled}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'></div>
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="type-label"
                            id="type"
                            name="selectedType"
                            label="Szabadság típusa"
                            errors={this.props.errors}
                            value={this.state.selectedType}
                            onChange={e => this.handleTypeChangeEvent(e)}
                            options={enums.vacationTypes}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="days"
                            label="Napok száma"
                            errors={this.state.errors}
                            value={this.state.days}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="startDate"
                            label="Kezdés"
                            variant="static"
                            value={this.state.startDate}
                            errors={this.state.errors}
                            shouldDisableDate={this.disableDays}
                            onChange={e => this.handleStartDateChangeEvent(e)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="endDate"
                            label="Befejezés"
                            variant="static"
                            value={this.state.endDate}
                            errors={this.state.errors}
                            shouldDisableDate={this.disableDaysForEndDate}
                            onChange={e => this.handleEndDateChangeEvent(e)} />
                    </div>
                </div>
                <div className="form-actions">
                    {this.state.partnerDisabled ? <></> :
                        <NewAgainField
                            checked={this.state.newAgain}
                            onChange={e => this.setState({ newAgain: e.target.checked })} />
                    }
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewVacation);
